var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('InputTransactionJournalV2',{attrs:{"selectedForm":"add","selectedJournal":_vm.selectedJournal,"unitList":_vm.unitList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }